/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseErrorInvalidRecordAllOfError } from './ResponseErrorInvalidRecordAllOfError';
import {
    ResponseErrorInvalidRecordAllOfErrorFromJSON,
    ResponseErrorInvalidRecordAllOfErrorFromJSONTyped,
    ResponseErrorInvalidRecordAllOfErrorToJSON,
} from './ResponseErrorInvalidRecordAllOfError';

/**
 * 
 * @export
 * @interface ResponseErrorInvalidRecordAllOf
 */
export interface ResponseErrorInvalidRecordAllOf {
    /**
     * 
     * @type {ResponseErrorInvalidRecordAllOfError}
     * @memberof ResponseErrorInvalidRecordAllOf
     */
    error: ResponseErrorInvalidRecordAllOfError;
}

/**
 * Check if a given object implements the ResponseErrorInvalidRecordAllOf interface.
 */
export function instanceOfResponseErrorInvalidRecordAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function ResponseErrorInvalidRecordAllOfFromJSON(json: any): ResponseErrorInvalidRecordAllOf {
    return ResponseErrorInvalidRecordAllOfFromJSONTyped(json, false);
}

export function ResponseErrorInvalidRecordAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorInvalidRecordAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': ResponseErrorInvalidRecordAllOfErrorFromJSON(json['error']),
    };
}

export function ResponseErrorInvalidRecordAllOfToJSON(value?: ResponseErrorInvalidRecordAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ResponseErrorInvalidRecordAllOfErrorToJSON(value.error),
    };
}

